import img3 from '../../assets/img/shop-shekil3.jpg';
import img4 from '../../assets/img/shop-shekil4.jpg';
import img6 from '../../assets/img/shop-shekil6.jpg';
import img8 from '../../assets/img/shop-shekil8.jpg';
import img5 from '../../assets/img/shop-shekil2.jpg';

const shopGalleryData = {
    shopGalleryData:[
        {
            id: 1,
            img: img3,
            
        },
        {
            id: 2,
            img: img4,
           
        },
        {
            id: 3,
            img: img6,
        },
        {
            id: 4,
            img: img8,
        },
        {
            id: 5,
            img: img5,
        },
        
    ]
}  
export default shopGalleryData;
